


















































































import { Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { RelativePayload } from '@/api/user/types'
import { mixins } from 'vue-class-component'
import Form from '@/mixins/form'
import VueQrCode from 'vue-weblineindia-qrcode'

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    VueQrCode
  }
})
export default class RelativeIndex extends mixins(Form) {
  $store!: ExStore
  inputs: RelativePayload = {
    firstName: '',
    lastName: '',
    firstNameReading: '',
    lastNameReading: '',
    email: ''
  }
  pendingInfo = true

  get errors() {
    return Object.entries(this.validator.messages).map(
      ([key, val]) => `${key}: ${val}\r`
    )
  }

  get patientInfo() {
    return this.$store.getters['user/patientInfo']
  }

  async created() {
    const editingData = this.$store.getters['user/sessionData'](
      'newRelative'
    ) as RelativePayload | null
    if (editingData) {
      this.inputs = editingData
    }

    this.pendingInfo = true
    this.$store.dispatch('user/updatePatientInfo').then(() => {
      this.pendingInfo = false
    })
  }

  handleConfirm() {
    if (this.validator.hasAnyError()) {
      this.$store.dispatch('alert/showErrorMessages', this.errors)
      return
    }

    this.$store.commit('user/setSessionData', {
      newRelative: { ...this.inputs }
    })
    this.$router.push({ name: 'PatientRelativeConfirm' })
  }
}
